//frontend/src/components/ChatBot.jsx


import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, ListGroup } from 'react-bootstrap';
import './ChatBot.css';

const ChatBot = () => {
    const [messages, setMessages] = useState([
        {
            id: 1,
            sender: 'bot',
            text: '👋 Bonjour ! Je suis l\'assistant E-Visa. Comment puis-je vous aider aujourd\'hui ?',
            timestamp: new Date()
        }
    ]);
    const [newMessage, setNewMessage] = useState('');
    const [isTyping, setIsTyping] = useState(false);
    const messagesEndRef = useRef(null);

    const quickQuestions = [
        '📝 Comment faire une demande ?',
        '💰 Quels sont les frais ?',
        '⏱️ Combien de temps ça prend ?',
        '📋 Documents nécessaires ?',
        '💼 Types de visa disponibles ?',
        '🌍 Pays éligibles ?'
    ];

    const responses = {
        'comment faire une demande': {
            text: `Pour faire une demande de visa de travail au Canada avec E-Visa, c'est simple :

1️⃣ Créez votre compte gratuitement sur notre plateforme
2️⃣ Remplissez le formulaire de demande en ligne
3️⃣ Téléchargez vos documents (passeport, CV, diplômes)
4️⃣ Notre équipe vérifie votre dossier
5️⃣ Nous soumettons votre demande aux autorités canadiennes

✅ Vous recevez des mises à jour régulières par email et sur votre tableau de bord.

Voulez-vous commencer maintenant ?`,
            quickReplies: ['Oui, commencer', 'Quels documents ?', 'Combien ça coûte ?']
        },
        'frais': {
            text: `💰 **Nos tarifs transparents :**

📌 Frais de service E-Visa : 299 € 
📌 Frais gouvernementaux : 155 CAD (environ 105 €)
📌 Total : environ 404 €

✨ **Ce qui est inclus :**
✓ Vérification complète de votre dossier
✓ Assistance personnalisée 24/7
✓ Suivi en temps réel de votre demande
✓ Correction illimitée de votre dossier
✓ Garantie de remboursement si refus

💡 Possibilité de paiement en plusieurs fois.`,
            quickReplies: ['Modes de paiement ?', 'Créer mon dossier', 'Autres questions']
        },
        'combien de temps': {
            text: `⏱️ **Délais de traitement :**

📅 **Avec E-Visa (service accéléré) :**
• Vérification de votre dossier : 2-3 jours
• Soumission officielle : 24h
• Réponse des autorités : 4-6 semaines en moyenne

📅 **Sans notre service :**
• Traitement standard : 8-12 semaines

🚀 **Notre avantage :** 
Nous optimisons votre dossier pour maximiser vos chances d'approbation rapide. 92% de nos clients obtiennent une réponse favorable !

⚡ Service express disponible pour les cas urgents.`,
            quickReplies: ['Service express ?', 'Commencer ma demande', 'Autres infos']
        },
        'documents': {
            text: `📋 **Documents nécessaires pour votre demande :**

**Documents obligatoires :**
✅ Passeport valide (minimum 6 mois)
✅ Photos d'identité récentes
✅ CV détaillé
✅ Diplômes et certificats
✅ Lettre de motivation
✅ Justificatifs d'expérience professionnelle

**Documents complémentaires (selon le cas) :**
📄 Offre d'emploi (si disponible)
📄 Relevés bancaires (3 derniers mois)
📄 Certificat de naissance
📄 Certificat de mariage (si applicable)

💡 **Conseil :** Tous les documents non en français/anglais doivent être traduits par un traducteur agréé.

Notre équipe vous guide pour chaque document !`,
            quickReplies: ['J\'ai tous les documents', 'Besoin d\'aide', 'Créer mon compte']
        },
        'types de visa': {
            text: `💼 **Nos services de visa disponibles :**

**1. Visa de Travail** 🔥 *Le plus demandé*
→ Pour travailler au Canada
→ Durée : 1 à 3 ans renouvelable
→ Voie vers la résidence permanente

**2. Visa d'Études** 📚
→ Pour poursuivre vos études au Canada
→ Permis de travail temps partiel inclus
→ Possibilité de rester après les études

**3. Visa Touristique** ✈️
→ Pour visiter le Canada
→ Durée : jusqu'à 6 mois
→ Démarches simplifiées

**4. Regroupement Familial** 👨‍👩‍👧
→ Rejoindre un proche au Canada
→ Pour conjoints, enfants, parents
→ Accompagnement complet

Quel type de visa vous intéresse ?`,
            quickReplies: ['Visa de travail', 'Visa d\'études', 'Autre type']
        },
        'pays éligibles': {
            text: `🌍 **Pays éligibles pour le visa de travail canadien :**

✅ **Tous les pays africains** dont :
• Bénin 🇧🇯 • Burkina Faso 🇧🇫 • Cameroun 🇨🇲
• Côte d'Ivoire 🇨🇮 • Gabon 🇬🇦 • Guinée 🇬🇳
• Mali 🇲🇱 • Niger 🇳🇪 • Sénégal 🇸🇳
• Togo 🇹🇬 • RDC 🇨🇩 • Et tous les autres !

✅ **Europe, Asie, Amérique du Sud** également éligibles

**Critères principaux :**
• Avoir au moins 18 ans
• Posséder un passeport valide
• Avoir une expérience professionnelle
• Maîtriser le français ou l'anglais (niveau de base acceptable)

💡 **Bonne nouvelle :** Le Canada accueille activement les talents du monde entier !

Êtes-vous prêt à postuler ?`,
            quickReplies: ['Oui, je postule', 'Voir les critères', 'Parler à un conseiller']
        },
        'oui': {
            text: `Excellent ! 🎉

Pour commencer votre demande de visa :

1️⃣ Cliquez sur le bouton "Créer mon compte" en haut
2️⃣ Remplissez vos informations personnelles
3️⃣ Créez votre premier dossier

Notre équipe prendra contact avec vous dans les 24h pour vous guider dans les prochaines étapes.

✅ L'inscription est gratuite et sans engagement !

Vous avez d'autres questions avant de commencer ?`,
            quickReplies: ['Créer mon compte', 'Questions sur les frais', 'Parler à un humain']
        },
        'parler': {
            text: `📞 **Parler à un conseiller humain :**

Nos conseillers sont disponibles :
• 📧 Email : contact@e-visa.com
• 📱 WhatsApp : +1 (XXX) XXX-XXXX
• ☎️ Téléphone : +33 X XX XX XX XX

⏰ **Horaires :**
Lundi - Vendredi : 9h - 18h (GMT)
Samedi : 10h - 14h (GMT)

💬 Vous pouvez aussi laisser un message via notre formulaire de contact et nous vous rappellerons dans les 2h ouvrées.

Souhaitez-vous laisser un message maintenant ?`,
            quickReplies: ['Laisser un message', 'Autre question', 'Créer mon compte']
        },
        'default': {
            text: `Je n'ai pas bien compris votre question. 😊

Voici ce que je peux vous aider à comprendre :

• Comment faire une demande de visa
• Les frais et tarifs
• Les délais de traitement
• Les documents nécessaires
• Les types de visa disponibles
• Les pays éligibles

Vous pouvez aussi parler directement à un de nos conseillers humains !

Quelle information recherchez-vous ?`,
            quickReplies: quickQuestions.slice(0, 3)
        }
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const getBotResponse = async (userMessage) => {
        const OPENROUTER_API_KEY = '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';

        const systemPrompt = `Vous êtes l'Assistant IA E-Visa, un expert en immigration canadienne spécialisé dans les visas de travail, d'études et touristiques.

Votre rôle principal :
- Aider les utilisateurs à naviguer sur la plateforme E-Visa
- Répondre efficacement à leurs questions sur les visas canadiens
- Identifier les problèmes qu'ils rencontrent et les guider vers les solutions
- Être concentré uniquement sur le projet E-Visa et ses fonctionnalités

Contexte de la plateforme E-Visa :
- Plateforme pour demandes de visas canadiens (travail, études, touristique, regroupement familial)
- Services : création de dossiers, suivi, notifications, chat avec admins
- Pages principales : Dashboard, Mes Dossiers, Profil, Paramètres, Notifications, Chat
- Pour admins : gestion des utilisateurs, dossiers, super admin pour paramètres système

Instructions importantes :
- Répondez toujours en français
- Soyez helpful, professionnel et encourageant
- Si l'utilisateur a un problème technique, guidez-le vers la bonne page ou action
- Si c'est une question sur les visas, donnez des infos précises mais dites de consulter un conseiller pour cas spécifiques
- Encouragez l'inscription et la création de dossiers
- Restez focus sur E-Visa, n'abordez pas d'autres sujets

Format de réponse :
- Commencez par reconnaître le problème/question
- Donnez une réponse claire et concise
- Si applicable, suggérez des actions concrètes sur la plateforme
- Terminez par une offre d'aide supplémentaire`;

        try {
            const response = await fetch('https://openrouter.ai/api/v1/chat/completions', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${OPENROUTER_API_KEY}`,
                    'Content-Type': 'application/json',
                    'HTTP-Referer': window.location.origin,
                    'X-Title': 'E-Visa Assistant IA'
                },
                body: JSON.stringify({
                    model: 'meta-llama/llama-3.2-3b-instruct:free',
                    messages: [
                        {
                            role: 'system',
                            content: systemPrompt
                        },
                        {
                            role: 'user',
                            content: userMessage
                        }
                    ],
                    max_tokens: 1000,
                    temperature: 0.7
                })
            });

            if (!response.ok) {
                throw new Error(`API Error: ${response.status}`);
            }

            const data = await response.json();
            const botMessage = data.choices[0]?.message?.content || 'Désolé, je n\'ai pas pu traiter votre demande. Veuillez réessayer.';

            return {
                text: botMessage,
                quickReplies: ['Autre question', 'Voir mon profil', 'Créer un dossier']
            };
        } catch (error) {
            console.error('OpenRouter API error:', error);
            return {
                text: 'Désolé, je rencontre un problème technique. Veuillez contacter le support ou réessayer plus tard.',
                quickReplies: ['Contacter support', 'Réessayer', 'Fermer']
            };
        }
    };

    const handleSendMessage = async (messageText = null) => {
        const textToSend = messageText || newMessage.trim();

        if (!textToSend) return;

        // Add user message
        const userMsg = {
            id: Date.now(),
            sender: 'user',
            text: textToSend,
            timestamp: new Date()
        };

        setMessages(prev => [...prev, userMsg]);
        setNewMessage('');
        setIsTyping(true);

        try {
            // Get bot response from OpenRouter API
            const botResponse = await getBotResponse(textToSend);
            const botMsg = {
                id: Date.now() + 1,
                sender: 'bot',
                text: botResponse.text,
                quickReplies: botResponse.quickReplies,
                timestamp: new Date()
            };

            setMessages(prev => [...prev, botMsg]);
        } catch (error) {
            console.error('Error getting bot response:', error);
            const errorMsg = {
                id: Date.now() + 1,
                sender: 'bot',
                text: 'Désolé, une erreur s\'est produite. Veuillez réessayer.',
                quickReplies: ['Réessayer', 'Fermer'],
                timestamp: new Date()
            };
            setMessages(prev => [...prev, errorMsg]);
        } finally {
            setIsTyping(false);
        }
    };

    const handleQuickQuestion = (question) => {
        // Remove emoji from question
        const cleanQuestion = question.replace(/[📝💰⏱️📋💼🌍]/g, '').trim();
        handleSendMessage(cleanQuestion);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleSendMessage();
    };

    return (
        <div className="chatbot-container">
            <div className="chatbot-messages">
                <ListGroup variant="flush">
                    {messages.map((msg) => (
                        <ListGroup.Item 
                            key={msg.id}
                            className={`chatbot-message ${msg.sender === 'user' ? 'user-message' : 'bot-message'}`}
                        >
                            <div className="message-content">
                                <div className="message-avatar">
                                    {msg.sender === 'bot' ? '🤖' : '👤'}
                                </div>
                                <div className="message-bubble">
                                    <div className="message-text">{msg.text}</div>
                                    {msg.quickReplies && msg.quickReplies.length > 0 && (
                                        <div className="quick-replies">
                                            {msg.quickReplies.map((reply, index) => (
                                                <Button
                                                    key={index}
                                                    size="sm"
                                                    variant="outline-primary"
                                                    className="quick-reply-btn"
                                                    onClick={() => handleSendMessage(reply)}
                                                >
                                                    {reply}
                                                </Button>
                                            ))}
                                        </div>
                                    )}
                                    <small className="message-time">
                                        {msg.timestamp.toLocaleTimeString('fr-FR', { 
                                            hour: '2-digit', 
                                            minute: '2-digit' 
                                        })}
                                    </small>
                                </div>
                            </div>
                        </ListGroup.Item>
                    ))}
                    {isTyping && (
                        <ListGroup.Item className="chatbot-message bot-message">
                            <div className="message-content">
                                <div className="message-avatar">🤖</div>
                                <div className="message-bubble">
                                    <div className="typing-indicator">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        </ListGroup.Item>
                    )}
                </ListGroup>
                <div ref={messagesEndRef} />
            </div>

            {/* Quick Questions */}
            <div className="quick-questions">
                <p className="quick-questions-title">Questions fréquentes :</p>
                <div className="quick-questions-grid">
                    {quickQuestions.map((question, index) => (
                        <Button
                            key={index}
                            size="sm"
                            variant="outline-secondary"
                            className="quick-question-btn"
                            onClick={() => handleQuickQuestion(question)}
                        >
                            {question}
                        </Button>
                    ))}
                </div>
            </div>

            {/* Input Form */}
            <div className="chatbot-input">
                <Form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <Form.Control
                            type="text"
                            placeholder="Posez votre question..."
                            value={newMessage}
                            onChange={(e) => setNewMessage(e.target.value)}
                            className="message-input"
                        />
                        <Button 
                            type="submit" 
                            variant="primary"
                            disabled={!newMessage.trim()}
                        >
                            Envoyer →
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default ChatBot;
